import React, { useContext, useState } from 'react';
import { FlowContext } from '../../core/flow-engine';
import InstitutionSelection from '../../components/InstitutionSelection/InstitutionSelection';
import TransferInstitutionHeader from '../../components/InstitutionHeader/TransferInstitutionHeader';
import styles from './styles.css';
import FundingInstitutionScreenFooter from './FundingInstitutionScreenFooter';
import { accountTypes } from '../../flows/shared/utils';
import RolloverInstitutionHeader from '../../components/InstitutionHeader/RolloverInstitutionHeader';

const FundingInstitutionScreen = () => {
  const {
    appState: {
      store: {
        accountType,
        loadedData: { institutions }
      }
    }
  } = useContext(FlowContext);

  const [manualProviderName, setManualProviderName] = useState('');

  return (
    <div className="institutions">
      {accountType === accountTypes.TRANSFER && <TransferInstitutionHeader />}

      {accountType === accountTypes.ROLLOVER && <RolloverInstitutionHeader />}

      <InstitutionSelection
        institutions={institutions}
        setManualProviderName={setManualProviderName}
      />

      <FundingInstitutionScreenFooter manualProviderName={manualProviderName} />

      <style jsx>{styles}</style>
    </div>
  );
};

export default FundingInstitutionScreen;
